<template>
  <div>
    <change-options v-if="currentStepAltMode === 'changeOptions'" />
    <div v-else class="step-container">
      <div class="row button-row">
        <div class="col-sm-4 results-filter">
          <label>Dollars:</label>
          <div class="btn-group">
            <button type="button" class="btn" @click="setFilter('today')" :class="getFilterCss('today')"
              v-popover.hover="tooltips.today">
              Today's
            </button>
            <button type="button" class="btn" @click="setFilter('future')" :class="getFilterCss('future')"
              v-popover.hover="tooltips.future">
              Future
            </button>
          </div>
        </div>
        <div class="col-sm-8 results-actions">
          <button type="button" class="btn btn-primary" @click="changeOptions">
            <i class="fa fa-caret-left" />
            Change Options
          </button>
          <button type="button" class="btn btn-primary" @click="startOver">
            Start Over
            <i class="fa fa-repeat" />
          </button>
          <button type="button" class="btn btn-primary" @click="showPrint">
            Print
            <i class="fa fa-caret-right" />
          </button>
        </div>
      </div>
      <div class="row tab-row">
        <div class="col-xs-12">
          <ul class="nav nav-tabs hidden-xs">
            <li v-for="tab in tabs" :key="tab.key" :role="tab.key"
              :class="{ active: tab.key === activeTab }">
              <a href="#" @click.prevent="setTab(tab.key)">
                {{ tab.label }}
              </a>
            </li>
          </ul>
          <div class="nav-responsive visible-xs">
            <dropdown>
              <button type="button" class="btn btn-default">
                {{ currentTab.label }}
                <i class="fa fa-caret-down" />
              </button>
              <template slot="dropdown">
                <li v-for="tab in otherTabs" :key="tab.key">
                  <a href="#" @click.prevent="setTab(tab.key)">
                    {{ tab.label }}
                  </a>
                </li>
              </template>
            </dropdown>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <overview v-if="activeTab === 'overview'" :filter="filter" @onMounted="clearLoading" />
          <tsp-summary v-if="activeTab === 'tsp-summary'" :filter="filter" @onMounted="clearLoading" />
          <all-payments v-show="activeTab === 'all-payments'" :filter="filter" @onMounted="clearLoading" />
          <all-numbers v-show="activeTab === 'all-numbers'" @onMounted="clearLoading" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ResultsMixin from '@/js/mixins/calculator/results/results-mixin';

import Overview from './overview';
import TspSummary from './tsp-summary';
import AllPayments from './all-payments';
import AllNumbers from './all-numbers';
import ChangeOptions from './change-options';

export default {
  mixins: [ResultsMixin],

  components: {
    'overview': Overview,
    'tsp-summary': TspSummary,
    'all-payments': AllPayments,
    'all-numbers': AllNumbers,
    'change-options': ChangeOptions,
  },
};
</script>

<style scoped lang="scss">
@import '~@/styles/resources';

.results-actions {
  text-align: right;
}

.results-filter, .results-actions {
  @media (max-width: $screen-xs-max) {
    margin-top: 10px;
    text-align: center;
  }
}

.button-row, .tab-row {
  margin-bottom: 15px;
}

.tab-row {
  .nav-tabs {
    margin-left: 0;
  }

  .nav-responsive {
    text-align: center;
    border-bottom: solid 1px $btn-default-border;

    button {
      border-bottom: none;
      margin-bottom: -1px;
    }
  }
}
</style>
